import Bacon from 'baconjs';
import $ from 'jquery';
import { createEmployeeCardRendering } from 'scripts/renderings/employee-rendering';

const createRadioButtonLabelRendering = (text, htmlClass) => {
  return `
      <label class="btn btn-default">
        <input type="radio" name="${htmlClass}" value="${text}"> ${text}
      </label>
    `;
};

const createRadioButtonFilterStream = (buttonsSelector) => {
  return $('body').asEventStream('change', buttonsSelector, e => e.currentTarget.value);
};

const checkRadioButton = ($radioButtonLabel) => {
  $radioButtonLabel.addClass('active');
  const $radioButtonInput = $radioButtonLabel.find('input');
  $radioButtonInput.attr('checked', 'checked').trigger('change');
};

const renderRadioButtons = ($buttonGroup, values, radioButtonName) => {
  if (!values || values.length <= 1) {
    $buttonGroup.parents('fieldset').hide();
  } else {
    $buttonGroup.parents('fieldset').show();
    const newRadioButtonLabelRenderings = values.map(val => createRadioButtonLabelRendering(val, radioButtonName));

    const $showAllRadioButtonLabel = $buttonGroup.find('label.show-all-button');
    const $oldRadioButtonLabels = $buttonGroup.find('label:not(.show-all-button)');

    checkRadioButton($showAllRadioButtonLabel);

    $oldRadioButtonLabels.remove();
    $buttonGroup.append(newRadioButtonLabelRenderings);
  }
};

const renderFilters = (locationFilter) => {
  renderRadioButtons($('#department-filter'), locationFilter.departments, 'department');
  renderRadioButtons($('#expertise-filter'), locationFilter.expertise, 'expertise');
};

const createFilterStream = (location, departmentFilterStream, expertiseFilterStream, searchTextFilterStream) => {
  return Bacon.combineTemplate({
    location,
    department: departmentFilterStream.startWith(''),
    expertise: expertiseFilterStream.startWith(''),
    searchText: searchTextFilterStream.startWith($('#search-text').val()),
  });
};

const createFilteredEmployeeStream = (employees, filterStream) => {
  return filterStream.map(filter => {
    return employees.filter(employee => {
      const isAtLocation = filter.location === '' || employee.context.locations.some(loc => loc === filter.location);
      const isAtDepartment = filter.department === '' || employee.context.departments.some(dep => dep === filter.department);
      const isAtExpertise = filter.expertise === '' || employee.context.expertise.some(exp => exp === filter.expertise);
      const searchTextMatchesName = !filter.searchText || (employee.name.toLowerCase().indexOf(filter.searchText.toLowerCase()) >= 0 || employee.title.toLowerCase().indexOf(filter.searchText.toLowerCase()) >= 0);
      return isAtLocation && isAtDepartment && isAtExpertise && searchTextMatchesName;
    });
  });
};

/* Merge two lists */
const mergeUnique = (originalList, newItems) => {
  return newItems.reduce((list, filterItem) => {
    if (list.indexOf(filterItem) < 0) {
      list.push(filterItem);
    }
    return list;
  }, originalList || []);
};

const getCombinedFilters = (locationFilters) => {
  const combinedFilters = locationFilters.reduce((c, filters) => {
    return Object.keys(filters).reduce((context, filter) => {
      if (filters[filter] instanceof Array) {
        context[filter] = mergeUnique(context[filter], filters[filter]);
      }
      return context;
    }, c); // reduce filters to object
  }, {}); // Reduce locationfilters to object
  combinedFilters.location = ''; // Set default empty location
  return combinedFilters;
};

const searchTextFilterStream = $('body').asEventStream('keyup', '#search-text', e => e.currentTarget.value).debounce(300);
const locationFilterStream = createRadioButtonFilterStream('input[name=location]');
const departmentFilterStream = createRadioButtonFilterStream('input[name=department]');
const expertiseFilterStream = createRadioButtonFilterStream('input[name=expertise]');

const initPageForLocationFilter = (data, locationFilter) => {
  const locationFilters = locationFilter || getCombinedFilters(data.locationFilters);
  renderFilters(locationFilters);

  const filterStream = createFilterStream(locationFilters.location, departmentFilterStream, expertiseFilterStream, searchTextFilterStream);
  const filteredEmployeesStream = createFilteredEmployeeStream(data.employees, filterStream);

  const $employeesContainer = $('#employees-container');
  let clearHandlers;

  const employeeHandler = filteredEmployeesStream.onValue(employees => {
    const employeeHtml = employees.map(e => createEmployeeCardRendering(e));
    $employeesContainer.html(employeeHtml);
    window.picturefill();
  });

  const searchHandler = searchTextFilterStream.onValue(() => {
    clearHandlers();
    $('#location-filter label.active').removeClass('active');
    checkRadioButton($('#location-filter label.show-all-button'));

    initPageForLocationFilter(data);
  });

  const locationHandler = locationFilterStream.onValue(clickedLocation => {
    // End streams
    clearHandlers();

    const clickedLocationFilters = data.locationFilters.filter(lf => lf.location === clickedLocation);
    const clickedLocationFilter = clickedLocationFilters.length > 0 ? clickedLocationFilters[0] : undefined;
    initPageForLocationFilter(data, clickedLocationFilter);
  });

  clearHandlers = () => {
    employeeHandler();
    locationHandler();
    searchHandler();
  };
};

const initPage = (data) => {
  const locationFilterItems = data.locationFilters.map(filter => createRadioButtonLabelRendering(filter.location, 'location'));
  $('#location-filter').append(locationFilterItems);
  initPageForLocationFilter(data, null);
};

export { initPage };
